import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import SliderItemForm from './SliderItemForm';

import CasinoSlidersApi from 'Api/CRM/Modules/CasinoSlidersApi';
import CasinoSliderItem from 'Api/Models/CasinoSliderItem';
import SweetAlert from 'crm/elements/alerts/SweetAlert';
import Card from 'crm/elements/common/Card';
import handleValidationErrors, { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';
import useNumberParams from 'crm/hooks/useNumberParams';
import useOnce from 'crm/hooks/useOnce';

function SliderItemEdit() {
    const { id } = useNumberParams();
    const history = useHistory();
    const [casinoSliderItem, setCasinoSliderItem] = useState<CasinoSliderItem>();
    const [errors, setErrors] = useState<ValidationErrors>({});

    const handelEditCasinoSliderItem = async (newCasinoSliderItem: CasinoSliderItem) => {
        const data = new FormData();
        data.append('casino_slider_id', String(newCasinoSliderItem.casino_slider_id));
        data.append('limit', String(newCasinoSliderItem.limit));
        data.append(
            'casino_game_category_translation_id',
            String(newCasinoSliderItem.casino_game_category_translation_id)
        );

        try {
            await SweetAlert.loader(CasinoSlidersApi.updateItem(id, data));
            await SweetAlert.success('Slider item updated correctly');
            history.push(`/casino-slider/${newCasinoSliderItem.casino_slider_id}`);
        } catch (error) {
            handleValidationErrors(error, setErrors);
        }
    };

    useOnce(() => CasinoSlidersApi.getItemById(id).then(setCasinoSliderItem));

    return (
        <Card title="Edit slider item">
            <SliderItemForm
                action={handelEditCasinoSliderItem}
                errors={errors}
                updatedCasinoSliderItem={casinoSliderItem}
            />
        </Card>
    );
}

export default SliderItemEdit;
